import React from 'react';
import { Box, Button, Card, CardContent, Container, Grid, Typography } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import ComputerIcon from '@mui/icons-material/Computer';
import { useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";
import { Link } from 'react-router-dom';
import { FONT_FAMILY } from 'common/sharedFunctions';

// Página pública de descargas de la app de escritorio Movex (Windows/macOS),
// pensada para gestión de flotas y talleres. Los enlaces se configuran en
// Información de la app (DesktopWindowsLink / DesktopMacLink).
export default function Downloads() {
  const settings = useSelector(state => state.settingsdata.settings);
  const { t } = useTranslation();

  const targets = [
    {
      key: 'windows',
      title: t('desktop_windows', { defaultValue: 'Windows' }),
      detail: t('desktop_windows_detail', { defaultValue: 'Instalador .exe · Windows 10 o superior' }),
      links: [
        { label: t('desktop_download', { defaultValue: 'Descargar' }), url: settings?.DesktopWindowsLink || '' },
      ],
    },
    {
      key: 'mac',
      title: t('desktop_mac', { defaultValue: 'macOS' }),
      detail: t('desktop_mac_detail', { defaultValue: 'Imagen .dmg · Elige tu chip' }),
      links: [
        { label: t('desktop_mac_arm', { defaultValue: 'Descargar Apple Silicon (M1+)' }), url: settings?.DesktopMacLink || '' },
        { label: t('desktop_mac_intel', { defaultValue: 'Descargar Intel' }), url: settings?.DesktopMacIntelLink || '' },
      ],
    },
  ];

  return (
    <Container maxWidth="md" sx={{ py: 6 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 1 }}>
        <ComputerIcon sx={{ fontSize: 40 }} color="secondary" />
        <Typography variant="h4" fontWeight={700} fontFamily={FONT_FAMILY}>
          {t('desktop_title', { defaultValue: 'Movex para escritorio' })}
        </Typography>
      </Box>
      <Typography fontFamily={FONT_FAMILY} sx={{ mb: 4 }}>
        {t('desktop_subtitle', { defaultValue: 'Gestiona tu flota, socios y talleres desde Windows o macOS con la misma cuenta del portal.' })}
      </Typography>
      <Grid container spacing={3}>
        {targets.map((item) => (
          <Grid item xs={12} sm={6} key={item.key}>
            <Card variant="outlined" sx={{ height: '100%' }}>
              <CardContent>
                <Typography variant="h6" fontWeight={700} fontFamily={FONT_FAMILY}>
                  {item.title}
                </Typography>
                <Typography fontFamily={FONT_FAMILY} sx={{ mb: 3 }}>
                  {item.detail}
                </Typography>
                {item.links.some((l) => l.url) ? (
                  <Box sx={{ display: 'flex', gap: 1.5, flexWrap: 'wrap' }}>
                    {item.links.filter((l) => l.url).map((l) => (
                      <Button key={l.label} variant="contained" color="secondary" startIcon={<DownloadIcon />} href={l.url}>
                        {l.label}
                      </Button>
                    ))}
                  </Box>
                ) : (
                  <Button variant="outlined" disabled>
                    {t('desktop_soon', { defaultValue: 'Próximamente' })}
                  </Button>
                )}
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
      <Box sx={{ mt: 4 }}>
        <Button component={Link} to="/">
          {t('desktop_back_home', { defaultValue: 'Volver al inicio' })}
        </Button>
      </Box>
    </Container>
  );
}
